import {Injectable} from '@angular/core';
import {ContractService} from "../contracts/contract.service";
import {PermissionNumbers} from "../../enums/permissions/permissionNumbers.enum";

@Injectable({
  providedIn: 'root'
})
export class BulkPermissionsService {

  constructor(private contractService: ContractService) {
  }

  private isMoral(contract: any): boolean {
    return contract && contract.perJuridicaTitular === 'PM'
  }

  private isNomina(contract: any): boolean {
    return contract && contract?.nomina === true;
  }

  private isPersonaFisicaActividadEmpresarial(contract: any): boolean {
    return contract && contract?.pfae === true;
  }

  private hasNumberPermission(contract:any): boolean {
    const permission = PermissionNumbers.BULK_PERMISSIONS;
    return this.contractService.checkPermissionNumberInContract(permission, contract?.idContrato);
  }

  hasBulkActionPermission(contract: any) {
    return this.hasNumberPermission(contract) && (this.isMoral(contract) || this.isNomina(contract) || this.isPersonaFisicaActividadEmpresarial(contract));
  }
}
